import React, { useEffect, useState } from "react";
import styles from "../onboard.module.css";
import AddressDetail from "./addressDetail";
import BeneficiaryBankDetail from "./beneficiaryBankDetail";
import { fetchDetails, fetchUser, statusApi } from "../../../api";
import { useMyContext } from "../../../myContext";

const BeneficiaryDetail = ({ stepToShow, setStepsToShow }) => {
  const [beneficiaryList, setBeneficiairyList] = useState([]);
  const [filteredList, setFilteredList] = useState([]);
  // const [beneficiaryCardSelection, setBeneficiaryCardSelection] =
  //   useState(false);
  const {
    beneficiaryCardSelection,
    setBeneficiaryCardSelection,
    setBeneficiarySecondFlow,
    completedRemitter,
    completedStudent,
    completedBeneficiary,
    setBeneficiaryBankSecondFlow,
    beneficiaryShortDetail,
    setBeneficiaryShortDetail,
    shortBeneficiaryBankDetail,
    setShortBeneficiaryBankDetail,
    showBeneficiaryDetail,
    setShowBeneficiaryDetail,
    showBeneficiaryBankDetail,
    setShowBeneficiaryBankDetail,
    beneficiaryBankCardSelection,
    setBeneficiaryBankCardSelection,
    beneficiaryUserId,
    studentUserId,
  } = useMyContext();

  // const [referenceNumber, setReferenceNumber] = useState(null);
  // const [beneficiaryData, setBeneficiaryData] = useState(null);
  const [isBeneficiaryFoamFlow, setIsBeneficiaryFoamFlow] = useState(false);
  const [beneficiaryLoader, setBeneficiaryLoader] = useState(false);
  const [addnewButton, setAddnewButton] = useState(false);
  const subPurpose = sessionStorage.getItem("subPurpose");

  const fetchStudentData = async () => {
    try {
      const response = await statusApi(studentUserId);
      if (response.status === 200) {
        // setReferenceNumber(response?.data?.referenceNumber ?? null);

        fetchBeneficiaryData(response?.data?.referenceNumber ?? null);

        // if (response?.data?.referenceNumber) {
        //   const mcaUser = await fetchUser(
        //     response?.data?.referenceNumber,
        //     "MCA"
        //   );
        //   if (mcaUser.status === 200) {
        //     setBeneficiaryData(mcaUser?.data.beneficiary ?? null);
        //   }
        // }
      }
    } catch (error) {
      console.log(error);
    }
  };

  const fetchBeneficiaryData = async (refNumber) => {
    setBeneficiaryBankCardSelection(false);
    setBeneficiaryBankSecondFlow(false);
    try {
      fetchDetails("beneficiary").then((response) => {
        setBeneficiaryLoader(false);

        setBeneficiairyList(response && response.data ? response.data : []);

        const filterListByCountry = (country) =>
          response.data.filter(
            (item) => item?.country?.toLowerCase() === country,
          );
        const getFilteredList = () => {
          if (subPurpose === "GIC (Canada)") {
            return filterListByCountry("canada");
          }
          if (subPurpose === "Blocked Account (Others)") {
            return filterListByCountry("germany");
          }

          if (refNumber) {
            const filteredByRefNum = response.data.filter(
              (item) => item.referenceNumber === refNumber,
            );

            setIsBeneficiaryFoamFlow(true);
            return filteredByRefNum;
          }

          return response.data;
        };
        if (beneficiaryUserId) {
          const selectedCard = response.data.find(
            (item) => item.userAccountId === beneficiaryUserId,
          );
          if (selectedCard) {
            let temporaryList = getFilteredList().filter(
              (item) => item.userAccountId !== beneficiaryUserId,
            );
            temporaryList.push(selectedCard);
            setFilteredList(temporaryList);
          }
        } else {
          setFilteredList(getFilteredList());
        }
        if (response && response.data && getFilteredList().length !== 0) {
          setBeneficiarySecondFlow(true);
          setBeneficiaryCardSelection(true);
          setAddnewButton(false);
        } else {
          setBeneficiaryCardSelection(false);
          setBeneficiarySecondFlow(false);
          setStepsToShow("BeneficiaryStep1");
          setAddnewButton(true);
        }
      });
    } catch (error) {
      setBeneficiaryLoader(false);
    }
  };

  useEffect(() => {
    if (
      completedRemitter &&
      completedStudent &&
      !completedBeneficiary &&
      !showBeneficiaryDetail
    ) {
      if (studentUserId) {
        fetchStudentData();
      }
      setBeneficiaryLoader(true);
    }
  }, [completedRemitter, completedStudent]);

  const fetchCardDetail = () => {
    setBeneficiaryCardSelection(true);
    setShowBeneficiaryDetail(false);
    setBeneficiaryLoader(true);
    fetchBeneficiaryData();
  };

  return (
    <div className={styles.cardDetails}>
      <>
        <h1 className={styles.onboardHeading}>3. Beneficiary</h1>
        {filteredList?.length === 0 ? (
          <>
            <AddressDetail
              isBeneficiaryFoamFlow={isBeneficiaryFoamFlow}
              stepToShow={stepToShow}
              setStepsToShow={setStepsToShow}
              shortDetail={beneficiaryShortDetail}
              setShortDetail={setBeneficiaryShortDetail}
              beneficiaryLoader={beneficiaryLoader}
              showBeneficiaryDetail={showBeneficiaryDetail}
              setShowBeneficiaryDetail={setShowBeneficiaryDetail}
              setShowBeneficiaryBankDetail={setShowBeneficiaryBankDetail}
              setBeneficiaryBankCardSelection={setBeneficiaryBankCardSelection}
              beneficiaryCardSelection={beneficiaryCardSelection}
              setBeneficiaryCardSelection={setBeneficiaryCardSelection}
              addnewButton={addnewButton}
              fetchCardDetail={fetchCardDetail}
            />
            <BeneficiaryBankDetail
              isBeneficiaryFoamFlow={isBeneficiaryFoamFlow}
              stepToShow={stepToShow}
              setStepsToShow={setStepsToShow}
              shortBankDetail={shortBeneficiaryBankDetail}
              setShortBankDetail={setShortBeneficiaryBankDetail}
              showBeneficiaryBankDetail={showBeneficiaryBankDetail}
              setShowBeneficiaryBankDetail={setShowBeneficiaryBankDetail}
              beneficiaryBankCardSelection={beneficiaryBankCardSelection}
              setBeneficiaryBankCardSelection={setBeneficiaryBankCardSelection}
            />
          </>
        ) : (
          <>
            <AddressDetail
              isBeneficiaryFoamFlow={isBeneficiaryFoamFlow}
              stepToShow={stepToShow}
              setStepsToShow={setStepsToShow}
              beneficiaryList={filteredList}
              shortDetail={beneficiaryShortDetail}
              setShortDetail={setBeneficiaryShortDetail}
              beneficiaryLoader={beneficiaryLoader}
              showBeneficiaryDetail={showBeneficiaryDetail}
              setShowBeneficiaryDetail={setShowBeneficiaryDetail}
              setShowBeneficiaryBankDetail={setShowBeneficiaryBankDetail}
              setBeneficiaryBankCardSelection={setBeneficiaryBankCardSelection}
              beneficiaryCardSelection={beneficiaryCardSelection}
              setBeneficiaryCardSelection={setBeneficiaryCardSelection}
              addnewButton={addnewButton}
              fetchCardDetail={fetchCardDetail}
            />
            <BeneficiaryBankDetail
              isBeneficiaryFoamFlow={isBeneficiaryFoamFlow}
              stepToShow={stepToShow}
              setStepsToShow={setStepsToShow}
              shortBankDetail={shortBeneficiaryBankDetail}
              setShortBankDetail={setShortBeneficiaryBankDetail}
              showBeneficiaryBankDetail={showBeneficiaryBankDetail}
              setShowBeneficiaryBankDetail={setShowBeneficiaryBankDetail}
              beneficiaryBankCardSelection={beneficiaryBankCardSelection}
              setBeneficiaryBankCardSelection={setBeneficiaryBankCardSelection}
            />
          </>
        )}
      </>
    </div>
  );
};
export default BeneficiaryDetail;
